module.exports = __webpack_public_path__ + "static/media/thunderkick.d701a3a3.svg";